import {
  Button,
  CircularProgress,
  IconButton,
  TextField,
} from "@material-ui/core";
import { Close, Remove } from "@material-ui/icons";
import React, { useState } from "react";
import firebase from "firebase";
import { db, storage } from "../../../firebase";

const makeDateFromTimestamp = (sec) => {
  if (!sec) {
    return null;
  }
  const t = new Date(1970, 0, 1);
  t.setSeconds(sec);
  const time = t.toISOString().substr(0, 10);
  // console.log(time);
  return time;
};

function EventForm({ state, setFetchAgain, data }) {
  const [videoUrls, setVideoUrls] = useState(
    data ? data.eventMedia.filter((item) => item.type === 1) : []
  );
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [eventFiles, setEventFiles] = useState([]);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [eventName, setEventName] = useState(data ? data.eventName : "");
  const [organizer, setOrganizer] = useState(data ? data.organizedBy : "");
  const [eventDesciption, setEventDesciption] = useState(
    data ? data.description : ""
  );
  const [date, setDate] = useState(
    data ? makeDateFromTimestamp(data.organizedOn.seconds) : ""
  );
  const [loading, setLoading] = useState(false);

  const uploadHandlerEvent = (e) => {
    // console.log(e.target.files);
    setEventFiles(e.target.files);
  };

  const uploadHandlerMedia = (e) => {
    // console.log(e.target.files);
    setMediaFiles(e.target.files);
  };

  const [, setVisible] = state;

  const submitHandler = async (key) => {
    setLoading(true);

    const firebaseDate = firebase.firestore.Timestamp.fromDate(new Date(date));
    // console.log(firebaseDate);

    try {
      //deleting files from FirebaseStorage
      if (key) {
        const listImagesEdit = await storage
          .ref(`Events/${key}/EventMedia`)
          .listAll();

        const posterImagesEdit = await storage
          .ref(`Events/${key}/EventPosters`)
          .listAll();

        for (let i = 0; i < listImagesEdit.items.length; i++) {
          await listImagesEdit.items[i].delete();
        }

        for (let i = 0; i < posterImagesEdit.items.length; i++) {
          await posterImagesEdit.items[i].delete();
        }
      }

      //-----------------------------
      const ref = db.collection("Events").doc(key ? key : undefined);
      const storageRef = storage.ref();

      //putting new files to eventPosters
      for (let i = 0; i < eventFiles.length; i++) {
        const newFile = eventFiles[i];
        const eventPostersRef = storageRef.child(
          `Events/${ref.id}/EventPosters/${newFile.name}`
        );
        await eventPostersRef.put(newFile);
        // console.log(`uploaded ${newFile.name}`);
      }

      //putting new files to eventMedia
      for (let i = 0; i < mediaFiles.length; i++) {
        const newFile = mediaFiles[i];
        const eventMediaRef = storageRef.child(
          `Events/${ref.id}/EventMedia/${newFile.name}`
        );
        await eventMediaRef.put(newFile);
        // console.log(`uploaded ${newFile.name}`);
      }

      const listImages = await storage //listing down filed from eventMedia
        .ref(`Events/${ref.id}/EventMedia`)
        .listAll();

      const posterImages = await storage //listing down files from eventPosters
        .ref(`Events/${ref.id}/EventPosters`)
        .listAll();

      // console.log(listImages.items);
      const eventMediaURL = []; //getting URL for eventMedia files for putting in DB
      for (let i = 0; i < listImages.items.length; i++) {
        const url = await listImages.items[i].getDownloadURL();
        eventMediaURL.push({ url, type: 0 });
        // console.log(url);
      }

      const posterURL = []; //getting URL for eventPosters files for putting in DB
      for (let i = 0; i < posterImages.items.length; i++) {
        const url = await posterImages.items[i].getDownloadURL();
        posterURL.push(url);
        // console.log(url);
      }

      // console.log("gotcha");
      // console.log(eventFilesURL);

      await ref.set({
        //putting up info to Firestore DB
        eventName,
        organizedBy: organizer,
        description: eventDesciption,
        key: ref.id,
        organizedOn: firebaseDate,
        eventMedia: [...videoUrls, ...eventMediaURL],
        posters: posterURL,
      });
      // console.log(resp);
      setFetchAgain((prev) => !prev);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }

    setVisible(false);
  };
  // console.log(eventFiles.forEach((t) => console.log(t)));

  return (
    <div
      className="eventForm_bg"
      onClick={(e) => {
        if (e.currentTarget === e.target) {
          setVisible(false);
        }
      }}
    >
      <div className="eventForm">
        <div className="eventForm__close__icon">
          <span>Event</span>
          <Close
            style={{ cursor: "pointer" }}
            onClick={() => setVisible(false)}
          />
        </div>
        {/* <h1>New Event</h1> */}
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <TextField
            label="Event Name"
            style={{ margin: "10px 2px", flex: "1" }}
            required
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
          />
          <TextField
            label="Organizer's Name"
            style={{ margin: "10px 2px", flex: "1" }}
            required
            value={organizer}
            onChange={(e) => setOrganizer(e.target.value)}
          />
        </div>

        <div>
          <textarea
            placeholder="Description of event"
            rows="5"
            value={eventDesciption}
            style={{ fontFamily: "sans-serif", padding: "5px", width: "100%" }}
            onChange={(e) => setEventDesciption(e.target.value)}
          />
        </div>

        <label className="eventForm__date">
          <span>Date of Event:</span>
          <input
            type="date"
            required
            style={{ fontFamily: "sans-serif" }}
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </label>

        <div className="eventForm__posters">
          <p style={{ marginRight: "5px" }}>Posters:</p>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={uploadHandlerEvent}
          />
          <div className="eventForm__posters__images">
            {Array.from(eventFiles).map((item, i) => (
              <span key={i}>{item.name}</span>
            ))}
          </div>
        </div>

        <div className="eventForm__media">
          <p
            style={{
              marginBottom: "10px",
              textAlign: "center",
              fontSize: "18px",
            }}
          >
            Event Media
          </p>
          <div className="eventForm__media__images">
            <p style={{ marginRight: "5px" }}>Images: </p>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={uploadHandlerMedia}
            />
            <div className="eventForm__posters__images">
              {Array.from(mediaFiles).map((item, i) => (
                <span key={i}>{item.name}</span>
              ))}
            </div>
          </div>

          <div className="eventForm__media__videos">
            <p>Video URLs:</p>
            {videoUrls.map((item, i) => (
              <div
                className="eventForm__videoList"
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "2px 0",
                }}
                key={i}
              >
                <span>{item.url}</span>
                <span>{item.title}</span>

                <IconButton
                  style={{ backgroundColor: "rgb(198, 08, 08)", padding: "0" }}
                  size="small"
                  onClick={() =>
                    setVideoUrls((prev) =>
                      prev.filter((it) => it.url !== item.url)
                    )
                  }
                >
                  <Remove fontSize="small" style={{ color: "white" }} />
                </IconButton>
              </div>
            ))}

            <div style={{ display: "flex" }}>
              <TextField
                label="Link"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                style={{ margin: "10px 3px", flex: "1" }}
              />

              <TextField
                label="Video title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={{ margin: "10px 3px", flex: "1" }}
              />
            </div>

            <textarea
              placeholder="Video description"
              value={description}
              rows="3"
              onChange={(e) => setDescription(e.target.value)}
              style={{
                fontFamily: "sans-serif",
                padding: "5px",
                fontSize: "15px",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "5px 0",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                disabled={!(url && title)}
                onClick={() => {
                  if (url && title) {
                    setVideoUrls((prev) => [
                      ...prev,
                      { url, title, description, type: 1 },
                    ]);
                    setUrl("");
                    setTitle("");
                    setDescription("");
                  }
                }}
              >
                Add
              </Button>
            </div>
          </div>
        </div>
        {loading ? (
          <div>
            <CircularProgress style={{ textAlign: "center" }} />
          </div>
        ) : (
          <>
            <p style={{ color: "red" }}>
              <i>
                * Event name, Organizer's name, Date, Posters are required
                fields
              </i>
            </p>
            <Button
              onClick={() => submitHandler(data?.key)}
              variant="contained"
              color="primary"
              disabled={
                eventName.length === 0 ||
                organizer.length === 0 ||
                date.length === 0 ||
                eventFiles.length === 0
              }
            >
              {data ? "Update" : "Submit"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

export default EventForm;
